
define( 'FORCES_AND_MOTION_BASICS/../nls/it/forces-and-motion-basics-strings',{
          "none": "Nullo",
          "force": "Forza",
          "values": "Valori",
          "frictionTitle": "Attrito",
          "redWins": "Il rosso vince!",
          "frictionForce": "Forza di attrito",
          "pause": "Pausa",
          "friction": "Attrito",
          "accelerationLab": "Accelerazione Lab",
          "forces-and-motion-basics.name": "Forze e moto: le basi",
          "appliedForce": "Forza applicata",
          "leftForce": "Forza sinistra",
          "massDisplay.pattern": "{0} Kg",
          "rightForce": "Forza destra",
          "acceleration": "Accelerazione",
          "sound": "Suono",
          "lots": "Massimo valore",
          "forces": "Forze",
          "motion": "Moto",
          "tugOfWar": "Tiro alla fune",
          "go": "Vai!",
          "newtons.n": "Newton (N)",
          "sumOfForcesEqualsZero": "Somma delle forze = 0",
          "blueWins": "Il blue vince!",
          "speed": "Velocità",
          "sumOfForces": "Somma delle forze",
          "return": "Indietro",
          "translation.credits": "Roberto Fanciulli, IT",
          "newtons": "Newton",
          "masses": "Masse",
          "forceReadout.pattern": "{0} N"
        } );